import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _DEAL_USER_TYPE_VS_PE, _PERSONA_DISPLAY_MAP, _PERSONA_API_MAP, _BUYER_TYPES_DISPLAY_, _DEAL_STATUS_DISPLAY_, _DEAL_STATUS_WEIGHTS, _DEAL_STATUS_COLOR_MA, _COLUMN_VS_RENDERER_T;

import _identity from 'lodash/identity';
import { getDefaultDateFormat } from 'tbase/utils/dateUtils';
import { DEAL_TYPES } from 'tbase/constants/deal/type';
import { DEAL_USER_TYPE } from 'tbase/constants/deal/userType';
import OPERATORS from 'tbase/constants/filterOperators';
import { snakeCaseToStartCase, formatCurrencyWithMoneyFormat } from '../utils';
export var PERSONAS = {
  SALES_PERSON: 'SALES_PERSON',
  BACK_OFFICE_CLERK: 'BACK_OFFICE_CLERK',
  SALES_MANAGER: 'SALES_MANAGER',
  F_nd_I_MANAGER: 'F_nd_I_MANAGER',
  CLOSING_MANAGER: 'CLOSING_MANAGER',
  BDC_SPECIALIST: 'BDCSpecialist',
  BDC_MANAGER: 'BDCManager',
  SALES_ADVISOR: 'SalesAdvisor',
  SALES_GREETER: 'SalesGreeter',
  INVENTORY_MANAGER: 'INVENTORY_MANAGER',
  DISPATCHER: 'Dispatcher',
  CASHIER: 'Cashier',
  WARRANTY_CLERK: 'Warranty_Clerk'
};
export var DEAL_USER_TYPE_VS_PERSONA = (_DEAL_USER_TYPE_VS_PE = {}, _defineProperty(_DEAL_USER_TYPE_VS_PE, DEAL_USER_TYPE.SALES_PERSON, [PERSONAS.SALES_PERSON]), _defineProperty(_DEAL_USER_TYPE_VS_PE, DEAL_USER_TYPE.SALES_MANAGER, [PERSONAS.SALES_MANAGER]), _defineProperty(_DEAL_USER_TYPE_VS_PE, DEAL_USER_TYPE.F_nd_I_MANAGER, [PERSONAS.F_nd_I_MANAGER]), _defineProperty(_DEAL_USER_TYPE_VS_PE, DEAL_USER_TYPE.CLOSING_MANAGER, [PERSONAS.CLOSING_MANAGER]), _defineProperty(_DEAL_USER_TYPE_VS_PE, DEAL_USER_TYPE.BDC_USER, [PERSONAS.BDC_MANAGER, PERSONAS.BDC_SPECIALIST]), _DEAL_USER_TYPE_VS_PE); // maps each persona to specific key in assignees

export var PERSONA_API_KEYS = {
  SALES_PERSON: 'salesPersons',
  SALES_MANAGER: 'salesManager',
  FNI_MANAGER: 'financeManager',
  CLOSING_MANAGER: 'closingManager',
  BACK_OFFICE_CLERK: 'backOfficeClerk'
};
export var PERSONA_DISPLAY_MAP = (_PERSONA_DISPLAY_MAP = {}, _defineProperty(_PERSONA_DISPLAY_MAP, PERSONAS.SALES_PERSON, 'Salesperson'), _defineProperty(_PERSONA_DISPLAY_MAP, PERSONAS.BACK_OFFICE_CLERK, 'Back Office Clerk'), _defineProperty(_PERSONA_DISPLAY_MAP, PERSONAS.SALES_MANAGER, 'Sales Manager'), _defineProperty(_PERSONA_DISPLAY_MAP, PERSONAS.F_nd_I_MANAGER, 'F & I Manager '), _defineProperty(_PERSONA_DISPLAY_MAP, PERSONAS.CLOSING_MANAGER, 'Closing Manager'), _PERSONA_DISPLAY_MAP);
export var PERSONA_API_MAP = (_PERSONA_API_MAP = {}, _defineProperty(_PERSONA_API_MAP, PERSONAS.SALES_PERSON, PERSONA_API_KEYS.SALES_PERSON), _defineProperty(_PERSONA_API_MAP, PERSONAS.BACK_OFFICE_CLERK, PERSONA_API_KEYS.BACK_OFFICE_CLERK), _defineProperty(_PERSONA_API_MAP, PERSONAS.SALES_MANAGER, PERSONA_API_KEYS.SALES_MANAGER), _defineProperty(_PERSONA_API_MAP, PERSONAS.F_nd_I_MANAGER, PERSONA_API_KEYS.FNI_MANAGER), _defineProperty(_PERSONA_API_MAP, PERSONAS.CLOSING_MANAGER, PERSONA_API_KEYS.CLOSING_MANAGER), _PERSONA_API_MAP);
export var BUYER_TYPE = {
  BUYER: 'BUYER',
  CO_BUYER: 'CO_BUYER'
};
export var BUYER_TYPES_DISPLAY_NAMES = (_BUYER_TYPES_DISPLAY_ = {}, _defineProperty(_BUYER_TYPES_DISPLAY_, BUYER_TYPE.BUYER, 'Buyer'), _defineProperty(_BUYER_TYPES_DISPLAY_, BUYER_TYPE.CO_BUYER, 'Co-Buyer'), _BUYER_TYPES_DISPLAY_);
export var TABLE_MANAGER_PROPS = {
  showSearch: false,
  showFilter: true,
  showSubHeader: true
};
export var DEAL_STATUS = {
  QUOTE: 'QUOTE',
  FINANCE_AND_INSURANCE: 'FINANCE_AND_INSURANCE',
  RECAP: 'RECAP',
  DOCS_SIGNING: 'DOCS_SIGNING',
  DOCS_PRINTED: 'DOCS_PRINTED',
  BOOKED: 'BOOKED',
  LOST: 'LOST',
  CREDIT_APPROVED: 'CREDIT_APPROVED',
  CLOSED_OR_SOLD: 'CLOSED_OR_SOLD',
  UNWIND: 'UNWIND',
  PRE_CLOSED: 'PRE_CLOSED',
  CONFIRMED: 'CONFIRMED'
};
export var DEAL_STATUS_DISPLAY_MAP = (_DEAL_STATUS_DISPLAY_ = {}, _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.QUOTE, 'Quote'), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.FINANCE_AND_INSURANCE, 'In F&I'), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.RECAP, 'In Recap'), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.DOCS_SIGNING, 'Docs Signing'), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.DOCS_PRINTED, 'Docs Printed'), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.BOOKED, 'Booked'), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.LOST, 'Lost'), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.CREDIT_APPROVED, 'CREDIT_APPROVED'), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.CLOSED_OR_SOLD, 'Closed or Sold'), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.UNWIND, 'Unwound'), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.PRE_CLOSED, 'Pre-closed'), _defineProperty(_DEAL_STATUS_DISPLAY_, DEAL_STATUS.CONFIRMED, 'Confirmed'), _DEAL_STATUS_DISPLAY_);
export var DEAL_STATUS_FILTER = [{
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.QUOTE],
  value: DEAL_STATUS.QUOTE
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.FINANCE_AND_INSURANCE],
  value: DEAL_STATUS.FINANCE_AND_INSURANCE
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.RECAP],
  value: DEAL_STATUS.RECAP
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.DOCS_SIGNING],
  value: DEAL_STATUS.DOCS_SIGNING
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.BOOKED],
  value: DEAL_STATUS.BOOKED
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.CLOSED_OR_SOLD],
  value: DEAL_STATUS.CLOSED_OR_SOLD
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.LOST],
  value: DEAL_STATUS.LOST
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.DOCS_PRINTED],
  value: DEAL_STATUS.DOCS_PRINTED
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.UNWIND],
  value: DEAL_STATUS.UNWIND
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.PRE_CLOSED],
  value: DEAL_STATUS.PRE_CLOSED
}, {
  label: DEAL_STATUS_DISPLAY_MAP[DEAL_STATUS.CONFIRMED],
  value: DEAL_STATUS.CONFIRMED
}];
export var DEAL_STATUS_WEIGHTS = (_DEAL_STATUS_WEIGHTS = {}, _defineProperty(_DEAL_STATUS_WEIGHTS, DEAL_STATUS.QUOTE, 1), _defineProperty(_DEAL_STATUS_WEIGHTS, DEAL_STATUS.CREDIT_APPROVED, 2), _defineProperty(_DEAL_STATUS_WEIGHTS, DEAL_STATUS.FINANCE_AND_INSURANCE, 4), _defineProperty(_DEAL_STATUS_WEIGHTS, DEAL_STATUS.CONFIRMED, 3), _defineProperty(_DEAL_STATUS_WEIGHTS, DEAL_STATUS.RECAP, 5), _defineProperty(_DEAL_STATUS_WEIGHTS, DEAL_STATUS.DOCS_SIGNING, 6), _defineProperty(_DEAL_STATUS_WEIGHTS, DEAL_STATUS.DOCS_PRINTED, 7), _defineProperty(_DEAL_STATUS_WEIGHTS, DEAL_STATUS.BOOKED, 8), _defineProperty(_DEAL_STATUS_WEIGHTS, DEAL_STATUS.PRE_CLOSED, 9), _defineProperty(_DEAL_STATUS_WEIGHTS, DEAL_STATUS.LOST, 10), _defineProperty(_DEAL_STATUS_WEIGHTS, DEAL_STATUS.CLOSED_OR_SOLD, 11), _DEAL_STATUS_WEIGHTS);
export var DEAL_ACTIVITY = {
  DEAL_CREATED: 'DEAL_CREATED',
  INSURANCE_ADDED: 'INSURANCE_ADDED',
  LINCENSE_ADDED: 'LINCENSE_ADDED',
  Trade_IN_VALUATION: 'Trade_IN_VALUATION',
  CREDIT_APPLIED: 'CREDIT_APPLIED',
  CREDIT_APPROVED: 'CREDIT_APPROVED',
  CREDIT_REJECTED: 'CREDIT_REJECTED',
  FNI: 'FNI',
  FNI_PRODUCTS_ADDED: 'FNI_PRODUCTS_ADDED',
  IN_RECAP: 'IN_RECAP',
  RECAPPED: 'RECAPPED',
  DOCS_SIGNING: 'DOCS_SIGNING',
  CUSTOMER_PAYMENT: 'CUSTOMER_PAYMENT',
  BOOKED: 'BOOKED',
  DEAL_POSTED: 'DEAL_POSTED',
  CLOSED_OR_SOLD: 'CLOSED_OR_SOLD',
  BANK_PAYMENT: 'BANK_PAYMENT',
  LOST: 'LOST',
  RETURNED: 'RETURNED',
  CUSTOMER_PAYMENT_REFUNDED: 'CUSTOMER_PAYMENT_REFUNDED',
  RETURNED_TO_QUOTE: 'RETURNED_TO_QUOTE'
};
export var DEAL_STATUS_COLOR_MAP = (_DEAL_STATUS_COLOR_MA = {}, _defineProperty(_DEAL_STATUS_COLOR_MA, DEAL_STATUS.QUOTE, '#FF8800'), _defineProperty(_DEAL_STATUS_COLOR_MA, DEAL_STATUS.FINANCE_AND_INSURANCE, '#FF8800'), _defineProperty(_DEAL_STATUS_COLOR_MA, DEAL_STATUS.RECAP, '#FF8800'), _defineProperty(_DEAL_STATUS_COLOR_MA, DEAL_STATUS.DOCS_SIGNING, '#FF8800'), _defineProperty(_DEAL_STATUS_COLOR_MA, DEAL_STATUS.DOCS_PRINTED, '#FF8800'), _defineProperty(_DEAL_STATUS_COLOR_MA, DEAL_STATUS.BOOKED, '#FF8800'), _defineProperty(_DEAL_STATUS_COLOR_MA, DEAL_STATUS.LOST, '#F52908'), _defineProperty(_DEAL_STATUS_COLOR_MA, DEAL_STATUS.CREDIT_APPROVED, '#FF8800'), _defineProperty(_DEAL_STATUS_COLOR_MA, DEAL_STATUS.CLOSED_OR_SOLD, '#FF8800'), _defineProperty(_DEAL_STATUS_COLOR_MA, DEAL_STATUS.UNWIND, '#FF8800'), _defineProperty(_DEAL_STATUS_COLOR_MA, DEAL_STATUS.PRE_CLOSED, '#FF8800'), _defineProperty(_DEAL_STATUS_COLOR_MA, DEAL_STATUS.CONFIRMED, '#FF8800'), _DEAL_STATUS_COLOR_MA);
export var CUSTOMER_TYPE = {
  BUYER: 'BUYER',
  CO_BUYER: 'CO_BUYER',
  OTHER: 'OTHER',
  BOTH: 'BOTH',
  NONE: 'NONE'
};
export var DEAL_JACKET = {
  DEAL: 'DEAL',
  VEHICLE: 'VEHICLE',
  TRADE_IN: 'TRADE_IN',
  CUSTOMER: 'CUSTOMER',
  FINANCE: 'FINANCE',
  PACKAGE: 'PACKAGE',
  ARCHIVED: 'ARCHIVED'
};
export var CUSTOMER_ADDRESS_TYPES = {
  CURRENT: 'CURRENT',
  PREVIOUS: 'PREVIOUS',
  GARAGE: 'GARAGE'
};
export var SORT_OPTION_FOR_SAME_KEY = {
  ASC: 'DESC',
  DESC: 'ASC'
};
export var TAG = 'DealList';
var FILTER_IDS = {
  STATUS: 'status',
  TYPE: 'type',
  ASSIGNEE_SALESPERSONS: 'assignee.salesPersons',
  ASSIGNEE_FINANCEMANAGER: 'assignee.financeManager',
  ASSIGNEE_SALESMANAGER: 'assignee.salesManager',
  DEALPAYMENT_PAYMENTOPTION_PAYMENTTYPE: 'dealPayment.paymentOption.paymentType',
  PRIMARYVEHICLE_VEHICLETYPE: 'primaryVehicle.vehicleType',
  PRIMARYVEHICLE_LOCATIONCODE: 'primaryVehicle.locationCode',
  MIGRATED: 'migrated',
  GROSSDETAILS_GLBALANCEAMT: 'grossDetails.glBalanceAmt',
  CREATED_TIME: 'createdTime'
};
export var DEFAULT_PAGE_SIZE = 20;
export var INITAIL_SORT_OBJECT = {
  key: 'createdTime',
  field: 'createdTime',
  order: 'DESC'
};
var RENDERER_TYPE = {
  TEXT: 'TEXT',
  PRICE: 'PRICE',
  USER: 'USER',
  DATE: 'DATE',
  NUMBER: 'NUMBER',
  NONE: 'NONE'
};
export var COLUMN_VS_RENDERER_TYPE = (_COLUMN_VS_RENDERER_T = {}, _defineProperty(_COLUMN_VS_RENDERER_T, RENDERER_TYPE.PRICE, formatCurrencyWithMoneyFormat), _defineProperty(_COLUMN_VS_RENDERER_T, RENDERER_TYPE.TEXT, snakeCaseToStartCase), _defineProperty(_COLUMN_VS_RENDERER_T, RENDERER_TYPE.NONE, _identity), _defineProperty(_COLUMN_VS_RENDERER_T, RENDERER_TYPE.DATE, getDefaultDateFormat), _COLUMN_VS_RENDERER_T);
export var DEAL_HEADER_ACTIONS = {
  DEALS_WITH_ZERO_GL_BALANCE: 'DEALS_WITH_ZERO_GL_BALANCE'
};
export var DEALS_WITH_ZERO_GL_BALANCE_PAYLOAD = [{
  operator: OPERATORS.IN,
  type: FILTER_IDS.STATUS,
  values: [DEAL_STATUS.BOOKED]
}, {
  operator: OPERATORS.BTW,
  type: FILTER_IDS.CREATED_TIME,
  values: [null, null, null]
}, {
  type: FILTER_IDS.MIGRATED,
  operator: OPERATORS.IN,
  values: [false]
}, {
  type: FILTER_IDS.TYPE,
  operator: OPERATORS.NIN,
  values: [DEAL_TYPES.FNI]
}, {
  type: FILTER_IDS.GROSSDETAILS_GLBALANCEAMT,
  operator: OPERATORS.LTE,
  values: [0]
}];
export var DEAL_STATUS_ACTING_AS_UNWIND = [DEAL_STATUS.UNWIND, DEAL_STATUS.LOST];
export var DEAL_STATUS_TO_NOT_SEND_TO_SALES = [DEAL_STATUS.QUOTE, DEAL_STATUS.BOOKED, DEAL_STATUS.CLOSED_OR_SOLD, DEAL_STATUS.PRE_CLOSED];
export var DEPOSIT_STATUS = {
  SUCCESS: 'SUCCESS',
  REVOKED: 'REVOKED',
  INTERMITTENT: 'INTERMITTENT'
};
export var DOCUMENT_TYPES = {
  DEAL: 'DEAL',
  FNI: 'FNI',
  ALL: 'ALL'
};
export var DEAL_SOURCE = {
  CONSUMER_DRS: 'CONSUMER_DRS'
};